import { get } from '@/common/services/request.js'

const state = {
  count: 0
}

const mutations = {
  ADD_COUNT: (state, num) => {
    if (num) state.count += num
  },
  SET_COUNT: (state, num) => {
    if (num || num === 0) state.count = num
  }
}

const actions = {
  /** 获取资源单数量 */
  getCount({ commit }) {
    get('items.seller.getShareSizeByUserId')
      .then(res => {
        if (res.success) {
          const count = (res.data && res.data[0] && res.data[0].value) || 0
          commit('SET_COUNT', count)
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  ADD_COUNT: ({ commit }, num) => {
    commit('ADD_COUNT', num)
  },
  SET_COUNT: ({ commit }, num) => {
    commit('SET_COUNT', num)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
